import { ensureLeadingHex } from "Utilities/Colors/colorUtils";

export const getBackgroundString = (colorScheme) => {
  const colorArr = colorScheme.map((elem) => ensureLeadingHex(elem));
  const colorStr = colorArr.join(", ");
  
  return `linear-gradient(135deg, ${colorStr})`;
};
